<template>
    <b-form
      :class="[inline ? 'gap-2 items-center' : '']"
      :inline="inline"
      @submit.prevent="onSubmit"
      @reset.prevent="clear"
      @reset="onReset"
      v-if="show">


      <b-form-group
        id="input-group-1"
        :label="$t('knowledge_item_title')"
        label-for="knowledge_item_title">
        <b-form-input
          id="knowledge_item_title"
          v-model="item.title"
          :placeholder="$t('knowledge_item_subject')"
          class="required"
          disabled>
        </b-form-input>
      </b-form-group>

      <b-form-group
        id="input-group-3"
        :label="$t('knowledge_item_category')"
        label-for="knowledge_item_category">
        <b-form-select
          id="knowledge-item-category"
          class="required-select"
          :options="knowledgeCategories"
          text-field="name"
          value-field="id"
          v-model="item.knowledge_category_id"
          disabled/>
      </b-form-group>

      <b-form-group
        id="input-group-2"
        :label="$t('knowledge_item_description')"
        label-for="knowledge_item_description"
        v-if="item.description">
        <div class="simple-content simple-editor simple-editor-disabled" v-html-safe="item.description"/>
      </b-form-group>

      <b-row class="m-0">
        <b-col
          lg="12">
          <h5 class="mt-2 mb-0">{{ $t('knowledge_subtitle_document') }}</h5>
          <vs-divider></vs-divider>
        </b-col>
      </b-row>

      <b-row class="pt-2">
        <b-col md="12">
          <media-list :medias="files"
                      :show-delete="false"
                      :action-on-click="false"/>
          <div class="flex flex-row justify-center" v-if="!files || files.length == 0">
            {{$t('msg_none_file')}}
          </div>
        </b-col>
      </b-row>

    </b-form>
</template>

<script>

import SelectSuggestion from '@/components/SelectSuggestion.vue'
import {required, min, email} from '@validations'
import {
  BForm,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormTextarea,
  BButton,
  BRow,
  BCol,
  VBTooltip,
} from 'bootstrap-vue'
import KnowledgeService from '@/services/api/KnowledgeService'
import MediaList from '@/components/media/MediaList.vue'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    SelectSuggestion,
    BForm,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormTextarea,
    BButton,
    BRow,
    BCol,
    MediaList,
  },
  props: {
    id: {
      type: Number,
      default: null
    }
  },
  data: () => ({
    service: null,
    item: {
      title: '',
      description: '',
      knowledge_category_id: ''
    },
    knowledgeCategory: {},
    knowledgeCategories: [],
    files: [],
    show: true,
    required, email, min
  }),
  methods: {
    loadKnowledgeCategories() {
      return this.service.getCategories().then(
        response => {
          this.knowledgeCategories = [
            ...response
          ]
        },
        error => {
          console.error('whoops')
        }
      )
    },
    onReset() {
      console.log('ret')
    },
    onSubmit() {

    },
    getData() {
      return this.service.read(this.id).then(
        response => {
          this.item.description = response.description || ''
          this.item.title = response.title
          this.item.knowledge_category_id = response.knowledge_category_id
          this.files = response.files
        },
        error => {
          console.error('oh no!')
        }
      )
    },
    goBack() {
      this.$router.push({
        name: 'knowledge-item-index'
      })
    },
    isEdit() {
      return (this.id != null || this.id != undefined)
    },

  },
  computed: {
    getFileUploadUrl() {
      const base = `${process.env.VUE_APP_API_BASE_URL}/api/v2`
      return `${base}/knowledge/items/${this.id}/files`
    },
  },
  beforeMount() {
    this.service = KnowledgeService.build(this.$vs)

    this.show = false
    const bootstrapRequests = []

    this.$vs.loading()

    bootstrapRequests.push(this.loadKnowledgeCategories())

    if (this.id) {
      bootstrapRequests.push(this.getData(this.id))
    }

    Promise.all(bootstrapRequests).then(
      () => this.show = true
    ).finally(
      () => this.$vs.loading.close()
    )
  },
}
</script>


<style lang="scss" scoped>
  @import 'src/assets/scss/simple-content.scss';

  ::v-deep .vs-popup {
    width: 800px !important;
  }
</style>
